import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import LoaderSvg from 'images/v5/icons/loader.svg';
import styles from './LinkButton.module.scss';
function LinkButton({ color = 'secondary', size = 's', disabled = false, loading = false, to, href, title, onClick, leftIcon, rightIcon, children = null, testId, }) {
    const isInactive = disabled || loading;
    const handleClick = (e) => {
        if (isInactive) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    const classes = classNames(styles.wrap, styles[color], styles[size], {
        [styles.disabled]: disabled,
        [styles.loading]: loading,
    });
    const icon = loading ? React.createElement(LoaderSvg, null) : leftIcon;
    const content = (React.createElement(React.Fragment, null,
        icon && React.createElement("span", { className: styles.icon }, icon),
        children && React.createElement("span", null, children),
        rightIcon && React.createElement("span", { className: styles.icon }, rightIcon)));
    if (href) {
        return (React.createElement("a", { href: href, className: classes, target: "_blank", rel: "noopener noreferrer", onClick: handleClick, "aria-disabled": isInactive || undefined, title: title, "data-test": testId }, content));
    }
    if (to) {
        return (React.createElement(Link, { to: to, className: classes, onClick: handleClick, "aria-disabled": isInactive || undefined, title: title, "data-test": testId }, content));
    }
    return (React.createElement("button", { type: "button", className: classes, disabled: disabled, "aria-busy": loading || undefined, onClick: handleClick, title: title, "data-test": testId }, content));
}
export default LinkButton;
